var exports = {
  "Gt": "hide-on-mobile__6ak-TF",
};

module.exports = exports;
